import { AppError } from '@/domain/ErrorApp.ts';
import { SingleTab } from '@/domain/singleTab.ts';
import { ItemMenu } from '@/domain/menu.ts';

export type GlobalAction =
  | { type: 'SET_ISDARK'; payload: boolean }
  | { type: 'SET_ERROR'; payload?: AppError }
  | { type: 'SET_TABS'; payload: SingleTab[] }
  | { type: 'SET_TAB'; payload: SingleTab }
  | { type: 'SET_TABS_PAGE_MAP'; payload: Record<string, ItemMenu> }
  | { type: 'SET_ACTIVE_TAB'; payload: string }
  | { type: 'SET_STATE_VIDEO'; payload: boolean }
  | { type: 'SET_RELOAD_PROJECT_LIST'; payload: boolean };

export const setIsDarkAction = (payload: boolean): GlobalAction => ({
  type: 'SET_ISDARK',
  payload,
});

export const setErrorAction = (payload?: AppError): GlobalAction => ({
  type: 'SET_ERROR',
  payload,
});

export const setTabsAction = (payload: SingleTab[]): GlobalAction => ({
  type: 'SET_TABS',
  payload,
});

export const setTabAction = (payload: SingleTab): GlobalAction => ({
  type: 'SET_TAB',
  payload,
});

export const setTabsPageMapAction = (payload: Record<string, ItemMenu>): GlobalAction => ({
  type: 'SET_TABS_PAGE_MAP',
  payload,
});

export const setActiveTabAction = (payload: string): GlobalAction => ({
  type: 'SET_ACTIVE_TAB',
  payload,
});

export const setStateVideoAction = (payload: boolean): GlobalAction => ({
  type: 'SET_STATE_VIDEO',
  payload,
});

export const setReloadProjectListAction = (payload: boolean): GlobalAction => ({
  type: 'SET_RELOAD_PROJECT_LIST',
  payload,
});
